import { useEffect, useState } from "react";
import "./imagegrid.css";
import { useNavigate } from "react-router-dom";

const ImageGrid = ({ data }) => {
  let navigate = useNavigate();
  return (
    <div className="image-container">
      {data?.length > 0 &&
        data.map((img, index) => (
          <img
            key={index}
            src={img?.image__image}
            alt="Banner"
            className={`image-item ${
              index === 0 ? "a1" : index === 1 ? "a2" : "a3"
            }`}
            onClick={() => navigate(`/${img.sub_slug ? img.sub_slug : "#"}`)}
          />
        ))}
    </div>
  );
};

export default ImageGrid;
